export default {
	text: "{changedBy} changed the sort order of KR <a href='#' data-action='key-result'>{name}</a> from {from} to {to}",
};
